import { render } from "./NutritionCopilot.vue?vue&type=template&id=37dc9424&scoped=true"
import script from "./NutritionCopilot.vue?vue&type=script&lang=js"
export * from "./NutritionCopilot.vue?vue&type=script&lang=js"

import "./NutritionCopilot.vue?vue&type=style&index=0&id=37dc9424&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dc9424"]])

export default __exports__